export type MetaAuthorizationState = 'unknown' | 'valid' | 'expiring' | 'expired' | 'access_lost';
export interface MetaAuthorizationHealth {
  state: MetaAuthorizationState;
  warningDays: number;
  checkedAt: string;
  tokenExpiresAt: string | null;
  dataAccessExpiresAt: string | null;
  expiresAt: string | null;
  deadlineSource: 'token' | 'data_access' | null;
  evidenceSource: 'meta_oauth' | 'meta_auth_error' | 'legacy_connection';
  observedAt: string | null;
  reason: string;
  action: string | null;
}
export interface MetaConnectionAlert {
  connectionId: string;
  owner: string;
  accounts: string[];
  authorization: MetaAuthorizationHealth;
}
export const metaAuthorizationLabels: Record<MetaAuthorizationState, string> = {
  unknown: 'Validade não informada',
  valid: 'Validade conhecida',
  expiring: 'Vence em breve',
  expired: 'Autorização expirada',
  access_lost: 'Acesso recusado pela Meta',
};
export const metaAuthorizationSourceLabels: Record<
  MetaAuthorizationHealth['evidenceSource'],
  string
> = {
  meta_oauth: 'Prazos informados pela Meta na autorização',
  meta_auth_error: 'Falha de autenticação devolvida pela Meta',
  legacy_connection: 'Estado de acesso salvo na conexão',
};
const parts = (instant: string) =>
  new Intl.DateTimeFormat('pt-BR', {
    timeZone: 'America/Sao_Paulo',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(new Date(instant));
/** An instant is presented in São Paulo; it is never rounded to decide whether it expired. */
export function formatMetaInstant(instant: string) {
  const fields = parts(instant);
  const value = (type: Intl.DateTimeFormatPartTypes) =>
    fields.find((part) => part.type === type)!.value;
  return `${value('day')}/${value('month')}/${value('year')} às ${value('hour')}:${value('minute')} (São Paulo)`;
}
export function metaInstantDay(instant: string) {
  const fields = parts(instant);
  const value = (type: Intl.DateTimeFormatPartTypes) =>
    fields.find((part) => part.type === type)!.value;
  return `${value('year')}-${value('month')}-${value('day')}`;
}
